const cards = [
  {
    title: '流浪地球3：人类命运的终章',
    tag: '科幻',
    rating: '9.8',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20style%20with%20futuristic%20space%20station%20and%20earth%20in%20background%2C%20dramatic%20warm%20amber%20lighting%2C%20dark%20atmosphere%2C%20film%20grain%20texture%2C%20epic%20scale%2C%20professional%20movie%20key%20art&width=600&height=800&seq=card-movie-01&orientation=portrait',
    desc: '太阳急速老化，人类面临终极抉择，地球拯救行动进入最后阶段',
  },
  {
    title: '封神第二部：武王伐纣',
    tag: '神话',
    rating: '9.6',
    img: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20movie%20poster%20with%20ancient%20warriors%20and%20golden%20palace%2C%20dramatic%20clouds%2C%20warm%20gold%20and%20crimson%20tones%2C%20dark%20cinematic%20background%2C%20high%20contrast%2C%20film%20poster%20style&width=600&height=800&seq=card-movie-02&orientation=portrait',
    desc: '西岐与朝歌的终极对决，封神大战一触即发',
  },
  {
    title: '热辣滚烫：蜕变之路',
    tag: '励志',
    rating: '9.5',
    img: 'https://readdy.ai/api/search-image?query=Inspirational%20drama%20movie%20poster%20with%20boxing%20gloves%20and%20warm%20sunset%20light%2C%20emotional%20tone%2C%20soft%20golden%20highlights%20on%20dark%20background%2C%20motivational%20sports%20theme%2C%20film%20poster%20aesthetic&width=600&height=800&seq=card-movie-03&orientation=portrait',
    desc: '一个普通人的不平凡蜕变，这个夏天最燃的励志故事',
  },
  {
    title: '飞驰人生3：最后的弯道',
    tag: '动作',
    rating: '9.3',
    img: 'https://readdy.ai/api/search-image?query=Racing%20movie%20poster%20with%20rally%20car%20on%20dusty%20track%20at%20sunset%2C%20dramatic%20golden%20light%2C%20action%20cinema%20vibe%2C%20dark%20edges%2C%20professional%20film%20key%20art%20style&width=600&height=800&seq=card-movie-04&orientation=portrait',
    desc: '巴音布鲁克赛道上最后的弯道之王，速度与荣耀的巅峰',
  },
  {
    title: '孤注一掷2：暗网猎杀',
    tag: '悬疑',
    rating: '9.1',
    img: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20with%20mysterious%20figure%20in%20shadow%2C%20red%20and%20dark%20color%20palette%2C%20suspenseful%20atmosphere%2C%20digital%20code%20elements%2C%20cinematic%20noir%20style&width=600&height=800&seq=card-movie-05&orientation=portrait',
    desc: '境外诈骗网络再度升级，一场没有退路的正邪较量',
  },
  {
    title: '哪吒之魔童闹海',
    tag: '动画',
    rating: '9.7',
    img: 'https://readdy.ai/api/search-image?query=Animated%20movie%20poster%20with%20mythical%20Chinese%20dragon%20and%20sea%20waves%2C%20vibrant%20red%20and%20gold%20colors%2C%20dramatic%20lighting%2C%20dark%20atmospheric%20background%2C%20epic%20fantasy%20art%20style&width=600&height=800&seq=card-movie-06&orientation=portrait',
    desc: '天地之大，我命由我不由天，哪吒再战四海八方',
  },
  {
    title: '长津湖之水门桥',
    tag: '战争',
    rating: '9.4',
    img: 'https://readdy.ai/api/search-image?query=War%20movie%20poster%20with%20soldiers%20in%20snowy%20mountain%20battlefield%2C%20cold%20blue%20white%20tone%2C%20dramatic%20cinematic%20lighting%2C%20dark%20atmosphere%2C%20epic%20historical%20film%20style&width=600&height=800&seq=card-movie-07&orientation=portrait',
    desc: '冰雪长津湖，铁血水门桥，铭记那段波澜壮阔的历史',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-2 h-6 md:h-7 rounded-full bg-accent-500"></span>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">精选推荐</h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10">编辑精选的优质好片，每一部都值得细细品味</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {cards.slice(0, 4).map((item, i) => (
            <div
              key={i}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/40 hover:border-primary-500/30 transition-all cursor-pointer"
            >
              <div className="relative w-full h-[200px] md:h-[240px] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 rounded bg-accent-500/80 text-background-50 text-[10px] font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-1 rounded bg-background-950/70 text-primary-400 text-xs font-bold">
                    {item.rating}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-50 group-hover:text-primary-400 transition-colors mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {cards.slice(4).map((item, i) => (
            <div
              key={i + 4}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/40 hover:border-primary-500/30 transition-all cursor-pointer"
            >
              <div className="flex">
                <div className="relative w-[120px] md:w-[150px] h-[160px] md:h-[190px] flex-shrink-0 overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-2 left-2">
                    <span className="px-1.5 py-0.5 rounded bg-accent-500/80 text-background-50 text-[10px] font-medium">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="flex-1 p-4 flex flex-col justify-center">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-heading text-sm font-semibold text-foreground-50 group-hover:text-primary-400 transition-colors">
                      {item.title}
                    </h3>
                    <span className="text-xs font-bold text-primary-400">{item.rating}</span>
                  </div>
                  <p className="text-xs text-foreground-400 leading-relaxed line-clamp-3">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}